import {enableProdMode, isDevMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import {AppModule} from './app/app.module';
import {environment} from './environments/environment';
import {logConsoleError} from './app/shared/shared-module-ui/utils/logger/logger';
import {handlePendingHardRefresh} from './app/shared/shared-utils/browser/hard-refresh.utils';

if (environment.production) {
  enableProdMode();
}

if (isDevMode() || !isDevMode()) {
  const origWarn = console.warn.bind(console);
  const mute = /(Firebase API called outside injection context|Calling Firebase APIs outside of an Injection context)/;
  console.warn = (...args: unknown[]): void => {
    const msg = String(args[0] ?? '');
    if (mute.test(msg)) return;
    origWarn(...args as []);
  };
}

if (!handlePendingHardRefresh()) {
  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => {
      logConsoleError('Bootstrap Module', {
        ts: 'main:platformBrowserDynamic',
        error: err,
      });

    });
}
